export const config = {
  API_BASE_URL: "https://api.connectri.in/api/v1",
  NODE_ENV: "development",
};
